import type { CurrentUserFetchResponse } from '@api/users/api.users.types';

export const yandexMetricaAuth = (
  metricaId: string,
  user: CurrentUserFetchResponse,
) => {
  if (user?.id && globalThis.ym) {
    globalThis.ym(metricaId, 'setUserID', user.id);
  }
};
